import { ConsolidatedLocationView, EventPanelMetadata } from '@mark43/cad-api';
import { useWatch } from 'react-hook-form';
import { useBootstrapState } from '../../../bootstrap/bootstrap-provider';
import { useEventMetadataStore } from '../../../event-panel/event-panel-form/event-metadata';
import { useEventLocationCautionsQuery } from '../../../event-panel/event-state/use-event-location-cautions-query';
import { useUnitAssignment } from '../../../unit-assignment/unit-assignment-context';
import { useIntegratedForm } from '../../../forms/use-integrated-form';

export const useUpdateDispositionOrClearEventContent = () => {
    const { eventPanelOptions } = useBootstrapState();
    const unitAssignment = useUnitAssignment();
    const { agencyId, agencyTypeGlobalAttrId } =
        useEventMetadataStore().state.metadata ?? ({} as EventPanelMetadata);

    const unitId = unitAssignment?.unitId;
    const isPrimaryUnit = !!unitAssignment?.isPrimary;

    const eventId = unitAssignment?.assignedEvent?.eventId;

    const eventForm = useIntegratedForm().form;

    const dispositionOptions = eventPanelOptions?.dispositionOptions;

    const { data: cautions, isLoading: areCautionsLoading } = useEventLocationCautionsQuery({
        eventId,
    });

    const eventLocation = useWatch({
        control: eventForm.control,
        name: 'location',
    }) as ConsolidatedLocationView;

    return {
        unitId,
        isPrimaryUnit,
        eventId,
        dispositionOptions,
        agencyId,
        agencyTypeGlobalAttrId,
        cautions,
        areCautionsLoading,
        eventLocation,
        eventForm,
    };
};
